export interface ClientDepartmentClass{
    AccountPartyDepartmentId:number
    AccountPartyId	:number
    PartyDepartmentCode	:string
    PartyDepartmentName	:string
    PartyDepartmentLocation	:string
    AccountLocationId :number
    //AccountPartyDepartmentGuidId:string
    isSelected : number
}

const common = {    
    AccountPartyId	:0,
    PartyDepartmentCode	:"",
    PartyDepartmentName	:"",
    PartyDepartmentLocation	:"",
  };
  
  export const clientDepartmentInitialsForAdd = { ...common };
  
  export const clientDepartmentInitialsForUpdate = {
    ...common,
    AccountPartyDepartmentId:0
  };